import { Text as Textt } from "@radix-ui/themes";

const Text: React.FC<{
  children?: React.ReactNode;
  isCentered?: boolean;
}> = ({ children, isCentered }) => {
  return (
    <Textt wrap="pretty" align={isCentered ? "center" : "left"}>
      {children}
    </Textt>
  );
};

export default Text;
